import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { postCall } from "../../utils/api";

const initialState = {
  data: [],
  error: "",
  statusCSV: "idle",
  invalidData: [],
};

export const addCSV = createAsyncThunk("CSV/add", async (data, thunkAPI) => {
  try {
    const response = await postCall("/admin/v1/add_csv", data);
    return await response;
  } catch (error) {
    // return Promise?.reject(error);
    if (error.response?.data?.invalid_data) {
      return thunkAPI.rejectWithValue({
        message:
          error.response.data.errors?.message?.[0] || "An error occurred",
        invalidData: error.response.data.invalid_data,
      });
    }
    return thunkAPI.rejectWithValue({
      message: error.message || "An unknown error occurred",
    });
  }
});

const CSVSlice = createSlice({
  name: "CSV",
  initialState,
  reducers: {
    clearInvalidData: (state) => {
      state.invalidData = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addCSV.pending, (state) => {
        state.statusCSV = "loading";
        state.error = null;
        state.invalidData = [];
      })
      .addCase(addCSV.fulfilled, (state, action) => {
        if (action.payload.success) {
          state.statusCSV = "succeeded";
          state.data.push(action.payload);
          state.invalidData = [];
          state.error = ""; 
        } else {
          state.statusCSV = "failed";
          state.error = action.payload.error;
        }
      })
      .addCase(addCSV.rejected, (state, action) => {
        state.statusCSV = "failed";
        state.error = action.error.message || "An unknown error occurred";
        state.invalidData = action.payload?.invalidData || [];
      });
  },
});

export const { clearInvalidData } = CSVSlice.actions;
export default CSVSlice.reducer;
